import React, { useState,useEffect } from 'react';
import './Form.css';
import { getAllQuestions } from './../../services/questions';
import { isExists } from './../../services/isExists';
import { postResults } from './../../services/leadData';
import { Modal } from 'react-bootstrap'; // Import Bootstrap Modal
import { Link } from 'react-router-dom';
import { getCountryCodeFromData } from "./../../utils/getCountryCode";
import { dataLayerTrack } from '../../utils/gtm';
import { getData, postData } from "../../utils/request";

const Form = () => {

  const pdfPaths = {
    termsOfService: require('./../../images/pdf/EC_DPRE_Trevi_T&C.pdf'),
    privacyPolicy: require('./../../images/pdf/EC_DPRE_Trevi_Privacy Policy.pdf'),
  };

  const openPDFInNewTab = (pdfPath) => {
    window.open(pdfPath, '_blank');
  };
  
  const [answers, setAnswers] = useState({});
  const [inputData, setInputData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    postal: '',
    city: '',
  });
  const [showForm, setShowForm] = useState(false);
  const [questionError, setQuestionError] = useState('');
  const [leadId, setLeadId] = useState(null);
  const [inputErrors, setInputErrors] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    postal: '',
    city: '',
  });
  const [inputError, setInputError] = useState('');
  const [primaryQuestions, setPrimaryQuestions] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  


  const handleBack = () => {
    setShowForm(false);
    setStep(1); // Switch back to the questionnaire form
    const formElement = document.getElementById('eligibility');

    if (formElement) {
      const formOffset = formElement.offsetTop -40;
      window.scrollTo({
        top: formOffset,
        behavior: 'smooth', // Optional: Add smooth scrolling effect
      });
    }
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    setShowFailureModal(false);
    setAnswers({});
    setInputData({
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      postal: '',
      city: '',
    })
    setQuestionError('');
    setInputErrors({
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      postal: '',
      city: '',
    });
    setInputError('');
    setAgreed(false)
    setShowForm(false);
    setStep(1);
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await getAllQuestions();
  //       setPrimaryQuestions(response.data?.body?.primaryQuestions || []); 
  //     } catch (error) {
  //       console.error('Error fetching questions:', error);
  //     }
  //   };

  //   fetchData();
  // }, []);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await getData(
            `${process.env.REACT_APP_GET_QUESTIONS}`
          );
          setPrimaryQuestions(response.data?.questions || []);
        } catch (error) {
          console.error("Error fetching questions", error);
        }
      };
      fetchData();
    }, []);

  const handleRadioChange = (questionId, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: value,
    }));
  };

  const handleInputChange = (field, value) => {
    setInputData((prevInputData) => ({
      ...prevInputData,
      [field]: value,
    }));

    // Validate individual input field
    const validationError = validateInputField(field, value);
    setInputErrors((prevInputErrors) => ({
      ...prevInputErrors,
      [field]: validationError,
    }));
  };

  const handleContinue = () => {
    const allQuestionsAnswered = Object.keys(answers).length === primaryQuestions.length;
    if (!allQuestionsAnswered) {
      setQuestionError('Please answer all questions before continuing...');
    } else {
      setQuestionError('');
      setShowForm(true);
      setStep(2);
    }
  };

  const handleSubmit = async () => {
    // Check if already submitting, if true, return
    if (isSubmitting) {
      console.log("Submission in progress. Please wait.");
      return;
    }

    setIsSubmitting(true);
    setIsLoading(true);
    try{
      const validationErrors = {};
      Object.entries(inputData).forEach(([field, value]) => {
        const error = validateInputField(field, value);
        if (error) {
          validationErrors[field] = error;
        }
      });
      setInputErrors(validationErrors);
  
      const firstErrorField = Object.keys(validationErrors)[0]; // Get the first field with an error
      if (firstErrorField) {
        const isMobile = window.innerWidth < 768; 
        var firstNameElement = document.getElementById(`${firstErrorField}Input`);
        if (isMobile) {
          const offset = 125; // Adjust the offset value as needed
          const targetScrollPosition = firstNameElement.offsetTop - offset;
          window.scrollTo({ top: targetScrollPosition, behavior: 'smooth' });
        } else {
          const eligibilityElement = document.getElementById('eligibility');
          if (eligibilityElement) {
            eligibilityElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
          }
        }
      }

     
      if (!agreed) {
        setInputError('Please agree to the terms before submitting.');
        return;
      }
      if (Object.values(validationErrors).some((error) => error !== '')) {
        console.log("Please resolve all the error to submit!!!")
        return;
      } else {
        setInputError('');
      }

      const formattedAnswers = primaryQuestions.reduce((acc, question) => {
      const answer = answers[question.Name]; // Get the answer for each question
      if (answer) {
        acc[question.Name] = answer; // Map the questionName to its answer
      }
      return acc;
    }, {});

    let trialCode = process.env.REACT_APP_TRIAL_CODE;
    let websiteTitle = process.env.REACT_APP_WEBSITE_TITLE;
    let phoneCountryCode = process.env.REACT_APP_PHONE_COUNTRY_CODE
    let phone = phoneCountryCode + inputData.phoneNumber;
    const requestData = {
      selectedAnswers: formattedAnswers,
      email: inputData.email,
      firstName: inputData.firstName,
      lastName: inputData.lastName,
      phone: phone,
      city: inputData.city,
      zipCode: inputData.postal,
      trialcode: trialCode,
      websitetitle:websiteTitle,
    };

    const storedUtmParams =
      JSON.parse(sessionStorage.getItem("utmParams")) || {};
    // If UTM parameters exist, map them to the new fields and add them to the requestData
    if (Object.keys(storedUtmParams).length > 0) {
      requestData.utmsource = storedUtmParams.utm_source || ""; // Mapping 'utm_source' to 'utmsource'
      requestData.utmmedium = storedUtmParams.utm_medium || ""; // Mapping 'utm_medium' to 'utmmedium'
      requestData.utmcampaign = storedUtmParams.utm_campaign || ""; // Mapping 'utm_campaign' to 'utmcampaign'
      requestData.utmcontent = storedUtmParams.utm_content || ""; // Mapping 'utm_content' to 'utmcontent'
    }
    console.log(requestData);

    const response = await postData(
      `${process.env.REACT_APP_POST_LEAD}`,
      requestData
    );
    console.log(response);
    if (response.status === 200) {
      setLeadId(response.data.LeadId); // Store the LeadId in state
      console.log("Lead ID saved:", response.data.LeadId);
      if (
        response.data.Iscreated === true &&
        response.data.Qualified === true
      ) {
        console.log("Success model");
        // setStep((prevStep) => prevStep + 1);
        // setShowSuccessModal(true);
        setShowSuccessModal(true);
      } else if (
        response.data.Iscreated === true &&
        response.data.Qualified === false
      ) {
        // console.log("Failure Model");
        // setStep((prevStep) => prevStep + 1);
        setShowFailureModal(true);
      } else if (
        response.data.Iscreated === false &&
        response.data.ErrorMessage != null
      ) {
        if (
          response.data.ErrorMessage ===
          `This phone number is already registered ${requestData.phone}`
        ) {
          setInputErrors((prevInputErrors) => ({
            ...prevInputErrors,
            phoneNumber:
              "Phone number is already in use. Please enter a different phone number.",
          }));
          return;
        } else {
          console.log("Something went wrong");
          return;
        }
      }
    } else {
      console.log("Something went wrong");
    }
    
    
      
    }finally{
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const validateInputField = (field, value) => {
    switch (field) {
      case 'firstName':
        if (value.length === 0) {
          return 'Please fill first name';
        }
        return value.length > 50 ? 'First Name should be less than or equal to 50 characters.' : '';
      case 'lastName':
        if (value.length === 0) {
          return 'Please fill last name';
        }
        return value.length > 50 ? 'Last Name should be less than or equal to 50 characters.' : '';
      case 'postal':
        if (value.length === 0) {
          return 'Please fill postal code';
        }
        return /^[a-zA-Z0-9]{1,7}$/.test(value) ? '':'Postal code should be alphanumeric with less than or equal to 7 characters.';
      case 'phoneNumber':
        if (value.length === 0) {
          return 'Please fill Phone Number';
        }
        return /^\d{10}$/.test(value) ? '' : 'Phone number should be 10 digits only.';
      case 'email':
        if (value.length === 0) {
          return 'Please fill email address';
        }
        // return /\.com$|\.in$/.test(value) ? '' : 'Email adress should end with .com or .in.';
        // /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.(com|in)$/i
        return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) ? '' : 'Email address should be valid.';
      case 'city':
        if (value.length === 0) {
          return 'Please fill city';
        }
          return value.length > 150 ? 'City Name should be less than or equal to 150 characters.' : '';
      default:
        return '';
    }
  };

  const validateInputFields = () => {
    const errors = {};
  
    if (!inputData.firstName) {
      errors.firstName = 'Please fill first name';
    }
    if (!inputData.lastName) {
      errors.lastName = 'Please fill last name';
    }
    if (!inputData.phoneNumber) {
      errors.phoneNumber = 'Please fill Phone Number';
    }
    if (!inputData.email) {
      errors.email = 'Please fill your email address';
    }
    if (!inputData.postal) {
      errors.postal = 'Please fill postal code';
    }
    if (!inputData.city) {
      errors.city = 'Please fill city';
    } 
    return errors;
  };
  

  const checkDuplicateField = async (fieldName, fieldValue) => {
    try {
      const response = await isExists(fieldName, fieldValue);
      return response.body; 
    } catch (error) {
      console.error(`Error checking duplicate ${fieldName}:`, error);
      return false; 
    }
  };

  const handleCheckboxChange = () => {
    // Clear inputError when the checkbox is checked
    setInputError('');
  };

  return (
    <div className="form">
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      {showForm && step === 2 && (
        <>
          <h2>GET ELIGIBILITY Results VIA EMAIL AFTER SUBMITTING YOUR DETAILS.</h2>
          <p className="mandatory">All fields are mandatory</p>
          <div className='secondscreen'>
            <div className='row'>
            <div className="details col-12 col-sm-6">
              <p className="inputdetails">First Name</p>
              <input
                type="text"
                id="firstNameInput"
                value={inputData.firstName}
                onChange={(e) => handleInputChange('firstName', e.target.value)}
                onKeyDown={(e) => {
                  // Allow only alphabetic input (a-z, A-Z)
                  if (!/[a-zA-Z]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
                placeholder="Enter First Name"
              />
              {inputErrors.firstName && <p className="error-message">{inputErrors.firstName}</p>}
            </div>

            <div className="details col-12 col-sm-6">
              <p className="inputdetails">Last Name</p>
              <input
                type="text"
                id="lastNameInput"
                value={inputData.lastName}
                onChange={(e) => handleInputChange('lastName', e.target.value)}
                onKeyDown={(e) => {
                  // Allow only alphabetic input (a-z, A-Z)
                  if (!/[a-zA-Z]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
                placeholder="Enter Last Name"
              />
              {inputErrors.lastName && <p className="error-message">{inputErrors.lastName}</p>}
            </div>

            <div className="details col-12 col-sm-6">
              <p className="inputdetails">Phone Number</p>
              <input
                type="tel"
                id="phoneNumberInput"
                value={inputData.phoneNumber}
                onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                onKeyDown={(e) => {
                  // Allow only numeric input (0-9)
                  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
                    e.preventDefault();
                  }
                }}
                placeholder="Enter Phone Number"
              />
              {inputErrors.phoneNumber && <p className="error-message">{inputErrors.phoneNumber}</p>}
            </div>

            <div className="details col-12 col-sm-6">
              <p className="inputdetails">Your Email Address</p>
              <input
                type="email"
                id="emailInput"
                value={inputData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                placeholder="Enter Email Address"
              />
              {inputErrors.email && <p className="error-message">{inputErrors.email}</p>}
            </div>

            <div className="details col-12 col-sm-6">
              <p className="inputdetails">Postal Code</p>
              <input
                type="text"
                id="postalInput"
                value={inputData.postal}
                onChange={(e) => handleInputChange('postal', e.target.value)}
                placeholder="Enter Postal code"
              />
              {inputErrors.postal && <p className="error-message">{inputErrors.postal}</p>}
            </div>

            <div className="details col-12 col-sm-6">
              <p className="inputdetails">City</p>
              <input
                type="text"
                id="cityInput"
                value={inputData.city}
                onChange={(e) => handleInputChange('city', e.target.value)}
                placeholder="Enter City Name"
              />
              {inputErrors.city && <p className="error-message">{inputErrors.city}</p>}
            </div>

            <div className="details1">
              <label>
                <input
                  name="checkbox"
                  type="checkbox"
                  checked={agreed}
                  onChange={() => {
                    // setAgreed(!agreed);
                    const newState = !agreed;
                    setAgreed(newState);
                    // Call handleCheckboxChange when the checkbox is changed
                    handleCheckboxChange();
                  }}
                />
                <span>By filling out this form, you agree to be contacted by phone, email, or text about this clinical research study.</span>
              </label>
              {inputError && <p className="error-message agree-condition-error">{inputError}</p>}
            </div>

          </div>
            <div className="row">		  
              <button className="btn btn-light back" onClick={handleBack}>
                Back
              </button>
              <button className="btn btn-light submit" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>

          <div className="privacy-links">
            <Link 
            // onClick={() => openPDFInNewTab(pdfPaths.privacyPolicy)}
             rel="noopener noreferrer">
              Privacy
            </Link>
           
            <Link 
            // onClick={() => openPDFInNewTab(pdfPaths.termsOfService)} 
            rel="noopener noreferrer">
              Term & Conditions
            </Link>
          </div>
          <p className="safedata">We take your information security seriously</p>
        </>
      )}
      
      {!showForm && step === 1 && (
        <>
          <h2>QUESTIONNAIRE TO CHECK YOUR ELIGIBILITY.</h2>
          {primaryQuestions
            // .sort((a, b) => a.seqNo - b.seqNo)
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((question,index) => (
              <div key={question.Name} className="questionnaire-item">
                <p className="question"><span>{index + 1}.</span> <span>{question.question}</span></p>
                <div className='yesorno'>
                  {question.options
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((option) => (
                      <div key={option.title} className="form-check form-check-inline">
                        <label className="form-check-label">
                        <input
                          type="radio"
                          // id={option.option}
                          id={`${question.Name}_${option.title}`}
                          name={`question_${question.Name}`}
                          value={option.title}
                          className="form-check-input radio-input"
                          // onChange={() => handleRadioChange(question.questionId, option.option)}
                          onChange={() => handleRadioChange(question.Name,option.title)}
                          // checked={answers[question.questionId] === option.option}
                        />
                        {option.title}</label>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          {questionError && <p className="error-message question-error">{questionError}</p>}

          {/* <button className="btn btn-light" onClick={handleContinue}>
            Continue
          </button> */}
          {primaryQuestions.length !==0 && (
            <button className="btn btn-light continue1" onClick={handleContinue}>
              Continue
            </button>
          )}
          {primaryQuestions.length ===0 && (
            <p>No questions available.</p>
          )}
        </>
      )}

      
      <Modal show={showSuccessModal} onHide={handleModalClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Thank you for sharing your details! Congratulations!, You passed the primary screening.</Modal.Title>
          
        </Modal.Header>
        <Modal.Body>
          <p><span>Next Steps</span>
          A registered nurse will get in touch with you shortly to guide you through the next phase of your participation.
</p>
          <p><span>Have Questions?</span>
          For any enquiries regarding the privacy of your information or if you need to make any updates, feel free to reach out to us at <Link to="" target='_blank'></Link></p>
         
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-light" onClick={handleModalClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFailureModal} onHide={handleModalClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Your Interest is Greatly Valued</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><span>Thank you for your interest in the trial</span></p>
          <p>Regrettably, it appears that you have not met the eligibility criteria.</p>
          <p><span>Your Contribution Matters</span>
          Even though this time wasn’t the right fit, your willingness to contribute to medical research is commendable. Thank you for your interest and efforts.</p>
          <p><span className="purple">Are you aware of anyone diagnosed with MG?</span>
          They might be eligible for the trial. Share this website with them and help them join our journey towards scientific discovery. Together, we can strive for a better future. Refer a friend or loved one today!
          </p>
          <p className=''><strong>If you have questions, please contact us at <a href=""></a></strong></p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-light" onClick={handleModalClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Form;